import { Pipe, PipeTransform } from '@angular/core';
import { IStayPriceColsHeaders, IStayPriceColsHeadersTraveller } from "../interfaces/stay-price-cols-headers";

@Pipe({
    name: 'travellerName'
})

export class TravellerNamePipe implements PipeTransform {
    public transform(colsHeader: IStayPriceColsHeaders, id: string): string {
        if(!id){
            return undefined;
        }
        return (colsHeader.traveller.find((traveller: IStayPriceColsHeadersTraveller) => traveller.id === id) || {name: undefined}).name;
    }
}